/* eslint-disable react-hooks/set-state-in-effect -- ignore*/
import { cx } from 'cva';
import { type FunctionComponent, useEffect, useRef, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import {
  LinearLoading,
  type LinearLoadingProps,
} from '../LinearLoading/LinearLoading';
import styles from './LoadingScreen.module.css';

export type LoadingScreenProps = LinearLoadingProps;

export const LoadingScreen: FunctionComponent<LoadingScreenProps> = ({
  className,
  description,
  showBibleVerse,
  showLogo,
}) => {
  const loadingDivRef = useRef<HTMLDivElement>(null);
  const [showLoading, setShowLoading] = useState(false);

  useEffect(() => {
    setShowLoading(true);
  }, []);

  return (
    <CSSTransition
      classNames={{
        enter: styles.fadeEnter,
        enterActive: styles.fadeEnterActive,
        exit: styles.fadeExit,
        exitActive: styles.fadeExitActive,
      }}
      in={showLoading}
      nodeRef={loadingDivRef}
      timeout={1000}
    >
      <div className={cx(styles.root, className)} ref={loadingDivRef}>
        <LinearLoading
          description={description}
          showBibleVerse={showBibleVerse}
          showLogo={showLogo}
        />
      </div>
    </CSSTransition>
  );
};
